// 全站 SEO / GEO 公共常量与工具。
// 服务端渲染(SSR)的公开页面用 pageProps.seo 传每页的标题/描述/结构化数据,Header 统一输出。

export const SITE_URL = 'https://hy.lingti.com'
export const SITE_NAME = '灵缇赛事系统'
export const BRAND = '灵缇互娱'
export const ORG_ID = `${SITE_URL}/#organization`
export const WEBSITE_ID = `${SITE_URL}/#website`
export const DEFAULT_OG_IMAGE = `${SITE_URL}/lingti-gd-logo.png`

export type SeoProps = {
  title?: string
  description?: string
  keywords?: string
  image?: string
  // 不带域名的路径,默认取当前路由(去掉 query)
  path?: string
  type?: 'website' | 'article'
  publishedTime?: string
  modifiedTime?: string
  noindex?: boolean
  jsonLd?: Record<string, any> | Record<string, any>[]
}

// 这些路由服务端直出正文(爬虫/AI 抓取不执行 JS 也能读到内容)。
// 页面本身渲染期不能碰 window/localStorage;新增前先在本地 curl 一下确认能出正文。
export const SSR_ROUTES = new Set([
  '/',
  '/news',
  '/news/[id]',
  '/post/[id]',
  '/baike',
  '/baike/[short_name]',
  '/rules',
  '/rules/[slug]',
  '/rules/g/[game]',
  '/rules/formats',
  '/about_us',
  '/contact',
  '/downloads',
  '/manual',
  '/manual/register_and_login',
  '/manual/create_match',
  '/manual/input_players',
  '/manual/set_rules',
  '/manual/arrange_table',
  '/manual/start_match',
  '/manual/input_score',
  '/manual/check_roster',
  '/manual/ranking_stats',
  '/fushiji',
  '/fushiji/faq',
  '/feedback/public',
  '/guide',
  '/guide/[slug]',
  '/sports/[sport]',
  '/events',
  '/match/[match_id]/info',
])

export const absUrl = (path = '/') => (path.startsWith('http') ? path : `${SITE_URL}${path.startsWith('/') ? '' : '/'}${path}`)

// HTML → 纯文本摘要(meta description 用)。不引 DOM,服务端可用。
export const plainText = (html = '', max = 150) => {
  const text = html
    .replace(/<(script|style)[^>]*>[\s\S]*?<\/\1>/gi, ' ')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/[#*>`_~|-]{2,}/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
  return text.length > max ? `${text.slice(0, max - 1)}…` : text
}

export const breadcrumbLd = (items: [string, string][]) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map(([name, path], i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name,
    item: absUrl(path),
  })),
})

export const faqLd = (qa: { q: string; a: string }[]) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: qa.map(({ q, a }) => ({
    '@type': 'Question',
    name: q,
    acceptedAnswer: { '@type': 'Answer', text: a },
  })),
})

// 序列化 JSON-LD 时转义 </script>,防止正文里的字符串截断脚本标签
export const ldJson = (data: any) => JSON.stringify(data).replace(/</g, '\\u003c')

// 赛制 → 项目名(赛事结构化数据 sport 字段、摘要文案用)
export const sportOfMatchType = (t = '') => {
  if (t.startsWith('pickleball')) return '匹克球'
  if (t === 'bridge') return '桥牌'
  if (t === 'zhong_hua_qiao_pai') return '中华侨牌'
  if (t === 'shuang_sheng') return '双升'
  if (t === 'four_players_team') return '升级'
  if (t === 'banquet') return '活动'
  return '掼蛋'
}
